export class LandingPageCustomization {
  constructor ({
    backgroundColor = '',
    logoImageUrl = '',
    rewardName = ''
  } = {}) {
    this.backgroundColor = backgroundColor
    this.logoImageUrl = logoImageUrl
    this.rewardName = rewardName
  }

  toJSON () {
    return {
      ...this
    }
  }
}
